<template>
  <div
    class="absolute-fill gc-border"
    v-bind:class="{ clickable: mode == 'view' }"
    v-on="mode == 'view' ? { click: () => $emit('click') } : {}"
  />
</template>

<style scoped>
.clickable {
  cursor: pointer;
  pointer-events: auto;
}
.clickable:hover {
  background-color: rgba(0, 0, 0, .2);
}
</style>

<script>
export default {
  name: 'giftcard-blob-controls',
  props: [ 'mode' ]
}
</script>
